/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PriceSearchResult = {
    id?: number;
    jan?: string;
    itemName?: string;
    imageUrl?: string;
    costPrice?: number;
    departmentCode?: number;
    lineCode?: number;
    classCode?: number;
    subclassCode?: number;
    departmentName?: string;
    lineName?: string;
    className?: string;
    subclassName?: string;
    lowerLimit?: number;
    itemCategoryName?: string;
    listPrice?: number;
    capacityOfUnit?: number;
    quantityOfUnit?: number;
    unit?: string;
    lowestSellingPrice?: number;
    discountedLowestSellingPrice?: number;
    lowestSellingUnitPrice?: number;
    lowestPriceTypeName?: string;
    effectiveEndDate?: string;
    competitorName?: string;
    edlpSellingPrice?: number;
    discountedEdlpSellingPrice?: number;
    edlpSellingUnitPrice?: number;
    competitorFlag?: boolean;
    nbpbkbn?: number;
    packingCategory?: PriceSearchResult.packingCategory;
    saratokuSellingPrice?: number;
    discountedSaratokuSellingPrice?: number;
    chomeSellingPrice?: number;
    taxRate?: number;
    pbleFlag?: boolean;
    discountedCategory?: string;
    lowestPriceType?: PriceSearchResult.lowestPriceType;
    stopPurchaseFlag?: boolean;
    sellingUnit?: number;
    exception?: boolean;
    prohibited?: boolean;
};
export namespace PriceSearchResult {
    export enum packingCategory {
        SINGLE_ITEM = 'SINGLE_ITEM',
        BALL = 'BALL',
        CASE = 'CASE',
        BUNDLE = 'BUNDLE',
        OTHER = 'OTHER',
    }
    export enum lowestPriceType {
        EDLP = 'EDLP',
        SARATOKU = 'SARATOKU',
        CHOME = 'CHOME',
        COMPETITOR = 'COMPETITOR',
        FRESHNESS = 'FRESHNESS',
        POS_CHANGED = 'POS_CHANGED',
        ORIGINAL_SELLING_PRICE_CHANGE = 'ORIGINAL_SELLING_PRICE_CHANGE',
        NULL = 'NULL',
        EMPTY = 'EMPTY',
    }
}

